import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { getClaims } from "../../../server/supabase/hooks/get-claims";

import type { Claims } from "../../../server/supabase/hooks/get-claims";

export const useClaims = (): Claims | undefined => {
  const [claims, setClaims] = useState<Claims>();
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    if (!isAuthenticated) return;
    void getAccessTokenSilently()
      .then((token) => {
        if (token !== undefined) setClaims(getClaims(token));
      })
      .catch(() => {});
  }, [getAccessTokenSilently, isAuthenticated]);
  return claims;
};
